import { initSharedLib } from '@frontend/shared/config';

import { constants } from './constants';

initSharedLib({
  isProd: constants.isProduction,
  passengerApiUrl: constants.passengerApi,
  storagePrefix: constants.storagePrefix,
  systemLocale: navigator.language,
  reloadSystem: () => window.location.reload(),
  storage: {
    setItem: (key, value) => localStorage.setItem(key, value),
    getItem: key => localStorage.getItem(key),
    removeItem: key => localStorage.removeItem(key),
  },
});
